import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import { colors } from "../materials/consts.stylex";
import { typography } from "../materials/typography.stylex";
const checkUrl = new URL("../icons/svg/ic_check_10dp.svg", import.meta.url).href;
const styles = {
    root: {
        kZKoxP: "x10w6t97",
        k1xSpc: "x78zum5",
        kGNEyG: "x6s0dn4",
        k7Eaqz: "xfb3i0g",
        k1K539: "x1e56ztr",
        kWkggS: "x1kf733v",
        kMzoRj: "xmkeg23",
        ksu8eU: "x1y0btm7",
        kVAM5u: "x5snjlz",
        kaIpWk: "x12oqio5",
        kMwMTN: "x12klvby",
        kWEjV4: "x1brutrg",
        $$css: true
    }
};
export function Checkbox({ label: label1, onChange, checked = false }) {
    const [state, setState] = React.useState(checked);
    React.useEffect(()=>{
        onChange(state);
    }, [
        state,
        onChange
    ]);
    return <label {...stylex.props(typography.table, styles.root)}>
      <input className="x10l6tqk xnalus7 xqtp20y xlb1s79 xmkeg23 x1y0btm7 x1wzfk3z xkib98w" type="checkbox" checked={state} onChange={()=>setState(!state)}/>
      <span {...{
        0: {
            className: "x1kky2od xlup9mm x1rg5ohu x12peec7 xmkeg23 x1y0btm7 x1wzfk3z x1cum3z5 xet2fuk x1db2dqx"
        },
        1: {
            className: "x1kky2od xlup9mm x1rg5ohu xmkeg23 x1y0btm7 x1wzfk3z x1cum3z5 xet2fuk x1db2dqx x6e1os3 x1v1fnrk xiy17q3 x1xsqp64 x1awj2ng"
        }
    }[!!state << 0]} style={state ? {
        backgroundImage: `url(${checkUrl})`
    } : undefined}/>
      <p>{label1}</p>
    </label>;
}
